<template>
  <div>
    <v-container fluid style="padding: 0 25px;">
      <v-card class="card2" style="margin-top: 10px">
        <v-col>
         <ModelManagement
          :editAction="isEditAction"
          v-model="GPTModel"
          :modelID="$route.query.id"
          :GetDDModel="isParam"
          :showValidationRuns="true"
          />
        </v-col>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" theme="dark">
        <v-card-text class="white--text">
          {{ $t("loadingpleasewait") }}
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
const LogTrace = checkPermissionTwo;
import ModelManagement from '@/components/ModelManagement.vue';
export default {
  name: 'GPTModeDetail',
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
  ],
  components: { ModelManagement },
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    id: null,
    dialog: false,
    isEditAction: false,
    today: null,
    GPTModel: {
      typeLLM:0,
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: '',
      gender: null,
      vectordbName: [],
      groupReplaceID: null,
      productGroupID: [],
      knowledgeGraphKeys: [],
      kgRetrievalConfig: null,
      topVDB: null,
      productTopVDB: null,
      productCosine: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      isBypass: false,
      isFeedback: false,
      isAllowImage: false,
      isShowNameUserMonitor: false,
      versioning: null,
      isPublish: true,
      modelIDGroup: null,
      modelDisplay: null,
      Len_ShortMemory: null,
      IsLongTerm_Memory: false,
      IsChainMassage: false,
      LenChainMassage: null,
      TimeSecondChainMassage: null,
      Cosine: null,
      DataIntegrationID : null,
      SqlModelID : null,
      promptSqlNoData : null,
      IntentGroupID : null,
      maximumChatInput : 200000,
      forbiddenWord:[""],
      jsonRequest:null,
      enableTime: null,
      timeZone: null,
      endPointURL: null,
      apI_Key: null,
      isAllowLLMChange: false,
      flowGroupID: null,
      categoryName: null,
    },
    isParam: "",
  }),
  watch: {
    '$route.params.id': function (newParam) {
      this.id = newParam;
    },
    'GPTModel.provider': function (val) {
      if (val == null) {
        this.GPTModel.vectordbName = [];
        this.GPTModel.topVDB = null;
      }
    },
  },
  methods: {
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1;

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    callGetDD(call){
      this.isParam = call;
    },
  },
  async mounted() {
    this.GetDate();
    this.callGetDD("GetAllDDModelManagement");
    this.callGetDD("getModel");
    if (!this.$route.query.id)
    {
      this.GPTModel.temperature = 0;
      this.GPTModel.topP = 0;
      this.GPTModel.gender = 'm';
      this.GPTModel.historyCount = 2;
      this.GPTModel.historyMinute = 10;
      this.GPTModel.Len_ShortMemory = 200;
      this.GPTModel.maximumChatInput = 200000;
    }
  },

}
</script>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}

.v-text-field :deep(label) {
  font-size: 0.9375rem;
}

.v-expansion-panel-header {
  padding: 0;
}
:deep(.expan-Pannel .v-expansion-panel--active > .v-expansion-panel-header) {
  min-height: 48px;
}
</style>
